export default "__VITE_ASSET__e9fc0cf7__"